import {
  MFAEmail,
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';

/**
 * Custom hook to determine if user needs to contact their host to setup MFA
 * Restricted users that have no phone or email on file
 * @returns boolean
 */
export const useShouldContactHost = () => {
  const isVIP = useWidgetState(Selectors.isVIPSelector) as boolean;
  const mobilePhone = useWidgetState(Selectors.securityMobilePhoneSelector) as
    | string
    | undefined;
  const marketingEmail = useWidgetState(Selectors.mfaMarketingEmailSelector) as
    | MFAEmail
    | undefined;
  const securityEmail = useWidgetState(Selectors.securityEmailSelector) as
    | string
    | undefined;

  return isVIP && !marketingEmail?.value && !securityEmail && !mobilePhone;
};
